import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const TextIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="text" ref={ref} {...props}>
      <path d="M20.32,4V7.85a.75.75,0,1,1-1.5,0V4.75H12.75V18.94h2.89a.75.75,0,0,1,0,1.5H8.36a.75.75,0,1,1,0-1.5h2.89V4.75H5.18v3.1a.75.75,0,0,1-1.5,0V4a.76.76,0,0,1,.75-.75H19.57A.75.75,0,0,1,20.32,4Z" />
    </Icon>
  ),
) as IconWithRender;

TextIcon.displayName = 'TextIcon';
TextIcon.renderIcon = (props) => <TextIcon {...props} />;
export default TextIcon;
